document.addEventListener("DOMContentLoaded", function () {
    const today = new Date();
    today.setHours(0, 0, 0, 0);  // set to midnight

    const sevenDaysAfter = new Date(today);
    sevenDaysAfter.setDate(today.getDate() + 7);

    let errorFound = false;

    // Loop through all line item properties
    document.querySelectorAll('.cart-item').forEach(item => {
        const textNodes = item.innerHTML.split('\n');
        textNodes.forEach(line => {
                const match = line.match(/<dd>(\d{4}-\d{2}-\d{2})/);  // find date in format YYYY-MM-DD
                if (match) {
                    const deliveryDate = new Date(match[1]);
                    deliveryDate.setHours(0, 0, 0, 0);

                    const diffInMs = Math.abs(deliveryDate - today);
                    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

                    console.log(diffInDays);

                    if (diffInDays + 1 < 7) {
                        errorFound = true;
                        item.insertAdjacentHTML('beforeend', '<p style="color:red;font-weight:bold;font-size:1.2rem;">⚠️ La fecha de entrega de uno de tus productos no está disponible. Favor de seleccionar otra opción.</p>');
                    }
                }
        });
    });

    // Disable checkout if error found
    if (errorFound) {
        const checkoutButton = document.querySelector('button[name="checkout"], .cart__checkout-button');
        if (checkoutButton) {
            checkoutButton.disabled = true;
            checkoutButton.style.backgroundColor = 'gray';
            checkoutButton.style.cursor = 'not-allowed';
            checkoutButton.title = "Actualiza las fechas de entrega para continuar";
        }
    }
});
